import { render } from "./BasicInfoEditModal.vue?vue&type=template&id=033553f4&scoped=true"
import script from "./BasicInfoEditModal.vue?vue&type=script&lang=js"
export * from "./BasicInfoEditModal.vue?vue&type=script&lang=js"

import "./BasicInfoEditModal.vue?vue&type=style&index=0&id=033553f4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033553f4"]])

export default __exports__